import { render, staticRenderFns } from "./OrderConfirm.vue?vue&type=template&id=ad1cd76e&scoped=true&"
import script from "./OrderConfirm.vue?vue&type=script&lang=ts&"
export * from "./OrderConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./OrderConfirm.vue?vue&type=style&index=0&id=ad1cd76e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1cd76e",
  null
  
)

export default component.exports